import CustomFilters from '@public/icons/filters_new.svg';
import React, { SVGProps } from 'react';

type CustomFiltersWrapperProps = SVGProps<SVGSVGElement>;
const CustomFiltersWrapper: React.FC<CustomFiltersWrapperProps> = (props) => {
  return <CustomFilters {...props} />;
};

export default CustomFiltersWrapper;
